import NestedForm from '/node_modules/stimulus-rails-nested-form/dist/stimulus-rails-nested-form.umd.js'
import axios from "axios";
import notify from "../../packs/notify";
import LoadingSpinner from "../../packs/loading_spinner";
import i18next from 'i18next';
import debounce from 'lodash.debounce';

export default class extends NestedForm {

  static targets = [
    "animalCard", 
    "addAnimal",
    "childIndex",
    "multipleAnimalContent",
    "item",
    "num",
    "autoCompleteInput",
    "autoCompleteHidden",
    "sexCodeId",
  ]

  static values = {
    // depending of DB record size
    animalsDbRecordSize: { type: Number, default: 0 },
    // comes from setup page
    setupAnimalCount: { type: Number, default: 0 },
    setupAnimalSexCodeId: { type: Number, default: 0 },
    setupAnimalBreedId: { type: Number, default: 0 },
    setupAnimalBreedLabel: { type: String, default: "" },
    setupIncrementalId: { type: String,  default: "" },
    accessionId: Number,
    submissionOriginType: String
  };

  connect() {
    super.wrapperSelectorValue = '.nested-form-animal-wrapper'
    super.connect()
    this.generateAnimalProcess()
    if (this.setupAnimalCountValue == 0){
      this.refreshIndexValue()
    } 
  }

  generateAnimalProcess(){
    LoadingSpinner("show")
    this.generateAnimal()
    .then(res => {
      this.addSetupIncrementalIdByOneBy() 
      this.addTaxonsToWholeAnimal()
      this.addSexCodeToWholeAnimal()
      this.refreshIndexValue()
      this.addAnimalCountDispatch()
      LoadingSpinner("hide")
    })
  }

  async generateAnimal(){    
    for (let index = 0; index < this.setupAnimalCountValue; index++) {
      if (this.setupAnimalCountValue > 1){
        await(this.startToAdd())
      }
    }
  }

  startToAdd = () => {
    return new Promise(resolve => {
      setTimeout(() =>
        resolve(this.add(new CustomEvent("add"), true)), 1);
    })
  }

  add(e, initial=false){
    super.add(e)
    this.displayToggleMultipleAnimalHeader()
    if (!initial) {
      this.refreshIndexValue()
      this.addAnimalCountDispatch()
    } 
  }

  addSetupIncrementalIdByOneBy(){
    const increment = this.setupIncrementalIdValue
    if (!increment) return

    let remainValue = increment
    const regexValue = increment.match(/\d+$/);
    let intValue = 0
    if (regexValue){
      intValue = parseInt(regexValue[0])
      remainValue = increment.slice(0, regexValue.index);
    }
    if (this.hasNumTarget){
      // if the originial value has last integer value we can set doing nothing if not we need to add + 1
      // like TEST100 > will start TEST100 /  TEST > will start TEST1
      if (intValue > 0 ){
        this.numTargets[0].value = increment
      } else  {
        this.numTargets[0].value = remainValue + (intValue + 1)
        intValue++
      }
    }

    for (let i = 1; i < this.numTargets.length; i++) {
      const lastItem =  this.numTargets[i];    
      if (lastItem) lastItem.value = remainValue + (intValue + i)
    }
  }


  addTaxonsToWholeAnimal(){
    const breedId = this.setupAnimalBreedIdValue
    const breedLabel = this.setupAnimalBreedLabelValue
    if (!breedId  || !breedLabel) return

    for (let i = 0; i < this.autoCompleteInputTargets.length; i++) {
      const inputItem =  this.autoCompleteInputTargets[i];
      const hiddenItem =  this.autoCompleteHiddenTargets[i];
      if (inputItem) inputItem.value = breedLabel
      if (hiddenItem) hiddenItem.value = breedId
    }
  }

  addSexCodeToWholeAnimal(){
    const sexCodeId = this.setupAnimalSexCodeIdValue
    if (!sexCodeId) return

    for (let i = 0; i < this.sexCodeIdTargets.length; i++) {
      const sexCodeItem =  this.sexCodeIdTargets[i];
      if (sexCodeItem) sexCodeItem.value = sexCodeId
    }
  }
  
  refreshIndexValue(){
    let total = 0 
    for (let index = 0; index < this.childIndexTargets.length; index++) {

      const target = this.childIndexTargets[index];
      target.innerHTML = (index + 1)

      const item = this.itemTargets[index]
      if (item) item.dataset.ordernumber = index + 1
      total += 1
    }
    let animal_count_info_id =  document.getElementById('animal_count_info_id')
    if (animal_count_info_id) {
      const i18Object = { count: total, submissionOriginType: i18next.t(this.submissionOriginTypeValue) }
      animal_count_info_id.innerHTML = i18next.t("You have total_submission_origin_type", i18Object)
    }
  }

  findTargetByQuerySelector(selector, e){
    const dataId = e.target.dataset.id
    return this.multipleAnimalContentTarget.querySelector(`${selector}[data-id="${dataId}"]`)
  }

  remove(e){
    const selectedCard = e.target.closest(this.wrapperSelectorValue);
    if (selectedCard.dataset.newRecord === 'true'){
      super.remove(e)
      this.refreshIndexValue()
      this.displayToggleMultipleAnimalHeader()
      this.addAnimalCountDispatch("delete")
    } else {
      this.deleteAnimal(e)
      .then(res => {
        this.displayToggleMultipleAnimalHeader()
        this.addAnimalCountDispatch("delete")
        return Promise.resolve("")
      })
    }
  }


  removeSingle(e){
    if (confirm("Deleting an Animal will also delete any Specimens owned by the animal. And after deleting you will be redirect the Setup page. Are you sure?") == true) {
      const removed = this.remove(e)
      let newRecord = e.target.dataset.newRecord
      if (!newRecord){
        removed.then(res =>{
          this.deleteSpecimensAndRedirectSetup()
        })
      } else {
        this.deleteSpecimensAndRedirectSetup()
      }
    } else {
      return false
    }
  }
  
  deleteSpecimensAndRedirectSetup(){
    const specimenCardSelector = "[data-portal--submission-specimen-target='specimenCard']"
    document.querySelectorAll(specimenCardSelector).forEach(e => e.remove());
    setTimeout(() => this.visitUrl("/portal/setup_tab?id="+this.accessionIdValue, "submission_form_tab"), 500)
  }

  async deleteAnimal(e){
    LoadingSpinner("show")
    let id = e.target.dataset.animalId
    let url = '/animals/'+ id +'.json'
    return axios({
      url: url, 
      method: 'DELETE',
    })
    .then(res => {
      const r = e.target.closest(this.wrapperSelectorValue);
      r.remove();
      LoadingSpinner("hide")
      this.refreshIndexValue()
      return Promise.resolve(res)
    })
    .catch((error) => {
      LoadingSpinner("hide")
      const msg = i18next.t('An error occurred when deleting the animal')
      notify({
        message: msg  + " : " + error,
        status: "error"
      });
    });
  }

  displayToggleMultipleAnimalHeader(){
    const maHeader = document.getElementById('multiple-animal-header')
    if (!maHeader) return
    maHeader.hidden = !this.hasItemTarget
  }


  visitUrl(url, frame) {
    Turbo.visit(url.toString(), { frame: frame });
  }

  addAnimalCountDispatch(type){
    if (!this.hasItemTarget) return
    this.dispatch("triggerAnimalCountProcess", {detail: { type: type, itemCount: this.itemTargets.length } })
  }

}
